export default __webpack_public_path__ + "assets/unimed-cuiaba-component.887fce87.svg";